/** Suppresses `beforeprint` Amplitude tracking while we drive print ourselves. */
let programmaticUntil = 0;

/**
 * Mark that the next print dialog was started by app code (button, Cmd+P,
 * certificate modal, etc.) so a window `beforeprint` listener does not also
 * record a browser-initiated `resource_print`.
 */
export const markProgrammaticPrint = (durationMs = 2000): void => {
  programmaticUntil = Date.now() + durationMs;
};

export const isProgrammaticPrint = (): boolean =>
  Date.now() < programmaticUntil;
